module.exports = __webpack_public_path__ + "img/rate-my-tactic--light.67d19fa6.png";